import React, { useState } from "react";
import { db, storage } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Navigation from "./Navigation";
import "./App.css";

function ReviewForm() {
  const [form, setForm] = useState({
    firstName: "",
    suburb: "",
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    reviewText: "",
    fileUrl: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const storageRef = ref(storage, `uploads/${file.name}`);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    setForm({ ...form, fileUrl: url });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addDoc(collection(db, "reviews"), {
      ...form,
      approved: false,
      createdAt: new Date(),
    });
    alert("Thank you! Your review has been submitted for verification.");
    setForm({
      firstName: "",
      suburb: "",
      q1: "",
      q2: "",
      q3: "",
      q4: "",
      q5: "",
      reviewText: "",
      fileUrl: "",
    });
  };

  return (
    <>
      <Navigation />
      <div className="form-container">
        <h2>Write Your Review</h2>
        <form onSubmit={handleSubmit}>
          <label>First Name:</label>
          <input name="firstName" value={form.firstName} onChange={handleChange} required />

          <label>Suburb / State:</label>
          <input name="suburb" value={form.suburb} onChange={handleChange} required />
          <label>Email: ( will not be public - only if admin needs to contact you )</label>
          <input name="email" value={form.suburb} onChange={handleChange} required />
          <label>Q1. Have your energy bill savings been in line with NRN's projections?</label>
          <select name="q1" value={form.q1} onChange={handleChange} required>
            <option value="">Select...</option>
            <option>Less savings than expected</option>
            <option>Accurate savings to NRN's projections</option>
            <option>Bill savings exceeded NRN projections</option>
          </select>

          <label>Q2. Do you have the ability to change energy providers on the NRN platform?</label>
          <select name="q2" value={form.q2} onChange={handleChange} required>
            <option value="">Select...</option>
            <option>Yes</option>
            <option>No</option>
            <option>Unsure</option>
          </select>

          <label>Q3. How satisfied are you with the installation of the NRN Solar + Battery system?</label>
          <select name="q3" value={form.q3} onChange={handleChange} required>
            <option value="">Select...</option>
            <option>Not satisfied</option>
            <option>Somewhat satisfied</option>
            <option>Very satisfied</option>
          </select>

          <label>Q4. How satisfied are you with NRN's after-sales communication?</label>
          <select name="q4" value={form.q4} onChange={handleChange} required>
            <option value="">Select...</option>
            <option>Not satisfied</option>
            <option>Somewhat satisfied</option>
            <option>Very satisfied</option>
          </select>

          <label>Q5. Would you recommend the NRN Solar + Battery package to your friends and family?</label>
          <select name="q5" value={form.q5} onChange={handleChange} required>
            <option value="">Select...</option>
            <option>Yes</option>
            <option>No</option>
          </select>

          <label>Please share your experience with the NRN Zero Cost Solar + Battery package:</label>
          <textarea
            name="reviewText"
            value={form.reviewText}
            onChange={handleChange}
            rows="10"
            required
          />

          <label>To ensure reviews are only made by NRN customers, please upload a recent energy bill (PDF):</label>
          <input type="file" accept="application/pdf" onChange={handleFileUpload} required />

          <p className="confidential-note">
            All uploads are treated as highly confidential and will be permanently deleted once verified.
          </p>

          <button type="submit">Submit Review</button>
        </form>
      </div>
    </>
  );
}

export default ReviewForm;
